export default __webpack_public_path__ + "static/ti_sparkle-2a168ae7544d34d67896e2affd03eb86.png";